import styles from './Spinner.module.css';

interface Props {
  /** If true, renders as a full-screen overlay. Otherwise inline. */
  overlay?: boolean;
  text?: string;
}

export default function Spinner({ overlay = false, text }: Props) {
  return (
    <div className={overlay ? styles.overlay : styles.inline}>
      <div className={styles.spinner} />
      {text && <p className={styles.text}>{text}</p>}
    </div>
  );
}
